<script>
  import { hasClass } from 'element-ui/src/utils/dom';
  // import ElDialog from 'element-ui/packages/dialog';
  import ElDialog from './element-dialog.vue';
  export default {
    name: 'JyDialog',
    extends: ElDialog,
    props: {
      closeOnClickModal: {
        type: Boolean,
        default: false
      },
      closeOnPressEscape: {
        type: Boolean,
        default: false
      },
      maxWidth: String,
      activatedLoad: Function,
      moveable: Boolean
    },
    data() {
      return {
        moveStyle: {},
        baseX: 0,
        baseY: 0,
        tX: 0,
        tY: 0,
        tX1: 0,
        tY1: 0
      }
    },
    computed: {
      style() {
        let style = {};
        if (!this.fullscreen) {
          style.marginTop = this.top;
          if (this.width) {
            style.width = this.width;
          }
          if (this.maxWidth) {
            style['max-width'] = this.maxWidth;
            style.width = '100%';
          }
        }
        return Object.assign({}, style, this.moveStyle);
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initMove();
            }, 800);
          });
        } else {
          let $el = this.$el.querySelector('.el-dialog__header');
          $el && ($el.removeEventListener('mousedown', this.handleMousedown));
        }
      }
    },
    created() {
      // activatedLoad callback
      this.$on('jy-activated', () => {
        if (this.visible && this.activatedLoad && this.activatedLoad instanceof Function) {
          this.activatedLoad();
        }
      });
    },
    mounted () {
      
    },
    beforeDestroy () {
      
    },
    methods: {
      initMove() {
        if (!this.moveable) {
          return;
        }
        let $el = this.$el.querySelector('.el-dialog__header');
        if ($el) {
          $el.addEventListener('mousedown', this.handleMousedown);
        }
      },
      handleMousedown(e) {
        if (!this.moveable) {
          return false;
        }
        if (hasClass(e.target, 'el-dialog__headerbtn') || hasClass(e.target, 'el-dialog__close')) {
          return false;
        }
        this.tX = (this.$refs.dialog.offsetLeft || this.tX1) + this.$el.scrollLeft,
        this.tY = (this.$refs.dialog.offsetTop || this.tY1) + this.$el.scrollTop;
        if (this.$refs.dialog.offsetLeft) {
          this.tX = this.$refs.dialog.offsetLeft / 2;
        }
        //this.moveStyle = {margin:0, transform:`translate(${this.tX}px, ${this.tY}px)`};
        this.baseX = e.clientX;
        this.baseY = e.clientY;
        // let posx = e.clientX - this.baseX, posy = e.clientY - this.baseY;
        document.onmousemove = (e) => {
          this.handleMove(e);
        };
        document.onmouseup = (e) => {
          this.handleUp(e);
        };

        e.stopPropagation();
        e.preventDefault();
      },
      handleMove(e) {
        this.tX1 = this.tX + (e.clientX - this.baseX), this.tY1 = this.tY + (e.clientY - this.baseY);
        if (this.tY1 < 0) {
          this.tY1 = 0;
        }
        if (this.tX1 < 0 && Math.abs(this.tX1) > this.$el.clientWidth - 200) {
          this.tX1 = 0 - (this.$el.clientWidth + 200);
        }
        this.moveStyle = {margin:0, transform:`translate(${this.tX1}px, ${this.tY1}px)`};
      },
      handleUp() {
        document.onmousemove = null;
        document.onmouseup = null;
      }
    }
  };
  </script>
  <style>
  @media (min-width: 576px) {
    
  }
  </style>